import {bymoTemplateMetadataFactoryCreate} from '../../../doppe-sdk';
import {
    bymoPageCreateDefaultNavigationSettings,
    BymoPageFeatureHasInnerPages,
    BymoPageHasSearchProps,
    bymoPageMigrateNavigationSettingsFromDefaultValues,
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata,
    BymoPageSocialLinksProps
} from '../../../client-server-common';
import {
    DoppeHideableValue,
    doppeHideableValueCreateHidden
} from '../../../client-server-common/types/doppe-hideable-value';
import {
    DoppeDtoAction,
    doppeDtoActionExtendWithDefaultProps
} from '../../../client-server-common/types/doppe-dto-action';
import {
    doppeDtoInnerPageCreateBlogPosts,
    doppeDtoInnerPageCreateDefaultProductsPage,
    doppeDtoInnerPageCreateEvents,
    doppeDtoInnerPageCreateBookings,
    doppeDtoInnerPageIsContent, doppeDtoInnerPageCreateProductPageSettings
} from '../../../client-server-common/types/doppe-dto-inner-page';
import {
    BymoTemplateSpeedDialActionsListAppearance,
    BymoTemplateSpeedDialAutoComplete,
    BymoTemplateSpeedDialHeaderAppearance,
    BymoTemplateSpeedDialMenuAppearance,
    BymoTemplateSpeedDialSearchAppearance,
    BymoTemplateSpeedDialSocialLinksAppearance
} from './bymo-template-speed-dial-common';

export namespace BymoTemplateSpeedDial {

    export interface TemplateProps extends BymoPageSocialLinksProps, BymoPageFeatureHasInnerPages , BymoPageHasSearchProps{
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete;
        showFullScreenAutoCompleteOnMobile: boolean;
        actionsHeading: DoppeHideableValue<string>;
        actionsListAppearance: BymoTemplateSpeedDialActionsListAppearance;
        bioText: DoppeHideableValue<string>;
        bioTextMaxLines: DoppeHideableValue<number>;
        headerAppearance: BymoTemplateSpeedDialHeaderAppearance;
        socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance;
        menuAppearance: BymoTemplateSpeedDialMenuAppearance;
    }
}

const TemplatePropsDefaultValues = () => {
    return {
        autoCompleteBehaviour: BymoTemplateSpeedDialAutoComplete.OnInputSearch as BymoTemplateSpeedDialAutoComplete,
        showFullScreenAutoCompleteOnMobile: false,
        showActionsInSearch: false,
        showLinksInSearch: true,
        actionsHeading: '',
        bioText: '',
        actionsListAppearance: BymoTemplateSpeedDialActionsListAppearance.Visible as BymoTemplateSpeedDialActionsListAppearance,

        socialLinks: [],
        bioTextMaxLines: doppeHideableValueCreateHidden(3),
        searchAppearance: BymoTemplateSpeedDialSearchAppearance.Hidden ,
        searchPlaceholder: doppeHideableValueCreateHidden(""),
        headerAppearance: BymoTemplateSpeedDialHeaderAppearance.Default ,
        socialLinksAppearance: BymoTemplateSpeedDialSocialLinksAppearance.Default ,
        menuAppearance: BymoTemplateSpeedDialMenuAppearance.Default,
        innerPages: [],
        defaultStoreProductsPage: doppeDtoInnerPageCreateDefaultProductsPage(),
        defaultBlogPostsPage: doppeDtoInnerPageCreateBlogPosts(),
        defaultEventsPage: doppeDtoInnerPageCreateEvents(),
        defaultBookingsPage: doppeDtoInnerPageCreateBookings(),
        defaultProductPage: doppeDtoInnerPageCreateProductPageSettings(),
        navigationSettings: bymoPageCreateDefaultNavigationSettings() // No inner pages initially,

    } as BymoTemplateSpeedDial.TemplateProps;
}


export const BymoTemplateSpeedDialTemplateMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateSpeedDial.TemplateProps>()({
    initialValues: TemplatePropsDefaultValues(),
    resolveProps: props => {
      const initialValues = TemplatePropsDefaultValues();

      const {
            innerPages = initialValues.innerPages,
            navigationSettings = initialValues.navigationSettings,
            ...restProps
        } = props;

        return {
            ...initialValues,
            socialLinksAppearance: (props.socialLinks && props.socialLinks.length > 0) ? BymoTemplateSpeedDialSocialLinksAppearance.Visible : BymoTemplateSpeedDialSocialLinksAppearance.Hidden,
            navigationSettings: bymoPageMigrateNavigationSettingsFromDefaultValues(navigationSettings, {
                profileName: typeof props.profileName === 'string' ? props.profileName : undefined,
            }),
            innerPages: innerPages.map(innerPage => {
                if (!doppeDtoInnerPageIsContent(innerPage)) {
                    return innerPage;
                }
                
                const {
                    actions,
                    ...innerPageRestProps
                } = innerPage;

                return {
                    ...innerPageRestProps,
                    actions: actions ? actions.map(action => {
                        return doppeDtoActionExtendWithDefaultProps(action as DoppeDtoAction<any>);
                    }) : [],
                }
            }),
            ...restProps
        }
    },
    templatePropsMetadata: {
        bioText: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        actionsHeading: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
        searchPlaceholder: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified),
    },
    features: [
        'hasActionButton',
        'hasProfileContent',
        'hasVisibleBackground',
        'hasCustomTextualContent',
        'hasActions',        // ✅ Single-page support
        'hasInnerPages',     // ✅ Multi-page support
        'canBeSkipped',
    ]
})